export default __webpack_public_path__ + "static/media/before.541dc6ce.png";